import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-form-conformite",
  templateUrl: "./form-conformite.component.html",
  styleUrls: ["./form-conformite.component.scss"],
})
export class FormConformiteComponent implements OnInit {
  @Input() idReception: number;
  @Input() idPatient: number;
  @Input() canUpdate: boolean;
  @Input() currentNC: any = {};

  @Output() close: EventEmitter<any> = new EventEmitter();

  busySave: Subscription;
  itemToSave: any = {};
  listSupports: any = [];
  listParametreNonConformite: any = [];
  listDomainesActivites: any = [];
  listActionRecommandees: any = [];
  listeNonConformites: any = [];
  user: any = {};

  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    public sanitizer: DomSanitizer
  ) {
    this.user = this.authService.currentUserValue;
  }

  addNonConformite() {
    if (!this.itemToSave || !this.itemToSave.supportId) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez sélectionner un support !",
        "bottom",
        "center"
      );
      return;
    }

    if (!this.itemToSave.paramId) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez sélectionner un paramètre !",
        "bottom",
        "center"
      );
      return;
    }

    if (!this.itemToSave.actionId) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez sélectionner une action !",
        "bottom",
        "center"
      );
      return;
    }

    let hasExiste = _.find(this.listeNonConformites, (o) => {
      return o.paramId == this.itemToSave.paramId;
    });

    if (hasExiste) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Ce paramètre est déjà dans le tableau !",
        "bottom",
        "center"
      );
      return;
    }

    let objToSave = { ...this.itemToSave };

    //Recuperer les libelles
    let currentSupport = _.find(this.listSupports, (o) => {
      return o.id == this.itemToSave.supportId;
    });
    let currentParam = _.find(this.listParametreNonConformite, (o) => {
      return o.id == this.itemToSave.paramId;
    });
    let currentAction = _.find(this.listActionRecommandees, (o) => {
      return o.id == this.itemToSave.actionId;
    });

    objToSave.supportLibelle = currentSupport?.libelle;
    objToSave.paramLibelle = currentParam?.libelle;
    objToSave.actionLibelle = currentAction?.libelle;

    this.listeNonConformites.push(objToSave);
  }

  deleteNonConformite(indice) {
    this.listeNonConformites.splice(indice, 1);
  }

  confirmSaveItem() {
    if (
     
      !this.itemToSave.actionImmediate ||
      !this.itemToSave.description
    ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner les champs obligatoires !",
        "bottom",
        "center"
      );
      return;
    }

    if (!this.listeNonConformites) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez ajouter les lignes de non conformité !",
        "bottom",
        "center"
      );
      return;
    }

    Swal.fire({
      title: "Enregistrer Non Conformité",
      text: "Confirmez-vous l'action ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#aaa4a4",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        let objSave = { ...this.itemToSave };

        objSave.datasLigneNonConformite = this.listeNonConformites;
        objSave.receptionId = this.idReception;

        this.saveItem(objSave);
      }
    });
  }

  saveItem(item) {
    var request = {
      user: this.user.id,
      datas: [item],
    };

    this.busySave = this.restClient
      .post(
        "ncNonConformite/" + (this.canUpdate ? "update" : "create"),
        request
      )
      .subscribe(
        (res) => {
          if (!res["hasError"]) {
            if (res["items"] && res["items"].length > 0) {
              this.utilities.showNotification(
                "snackbar-success",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );

              this.handleClose(true);
            }
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
        }
      );
  }

  handleClose($event) {
    this.close.emit($event);
  }

  getSupport() {
    let request = {
      user: this.user.id,
      data: {},
    };

    this.busySave = this.restClient
      .post("ncSupport/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.listSupports = res["items"];
          } else {
            this.listSupports = [];
          }
        },
        (err) => {}
      );
  }

  getDefaultNonConformite() {
    let request = {
      user: this.user.id,
      data: {
        receptionId : this.idReception
      },
    };

    this.busySave = this.restClient
      .post("ncNonConformite/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemToSave = {...res["items"][0]};
            this.canUpdate = true;
             if (this.itemToSave) {
              this.listeNonConformites = [...this.itemToSave.datasLigneNonConformite];
            }
          } else {
            this.currentNC = {}
          }
        },
        (err) => {}
      );
  }

  getActionsRecommande() {
    let request = {
      user: this.user.id,
      data: {},
    };

    this.restClient.post("ncActionRecom/getByCriteria", request).subscribe(
      (res) => {
        if (res && res["items"]) {
          this.listActionRecommandees = res["items"];
        } else {
          this.listActionRecommandees = [];
        }
      },
      (err) => {}
    );
  }

  getParametreNC(idSupport) {
    let request = {
      user: this.user.id,
      data: {
        supportId: idSupport,
      },
    };

    this.restClient.post("ncParam/getByCriteria", request).subscribe(
      (res) => {
        if (res && res["items"]) {
          this.listParametreNonConformite = res["items"];
        } else {
          this.listParametreNonConformite = [];
        }
      },
      (err) => {}
    );
  }

  getDomaineActivite() {
    let request = {
      user: this.user.id,
      data: {},
    };

    this.restClient.post("ncDomaineActivite/getByCriteria", request).subscribe(
      (res) => {
        if (res && res["items"]) {
          this.listDomainesActivites = res["items"];
        } else {
          this.listDomainesActivites = [];
        }
      },
      (err) => {}
    );
  }

  ngOnInit(): void {
    this.getSupport();
    this.getDomaineActivite();
    this.getActionsRecommande();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["currentNC"] && changes["currentNC"].currentValue) {
      this.itemToSave = { ...changes["currentNC"].currentValue };

      console.log(" this.itemToSave ",this.itemToSave);

      if (this.itemToSave) {
        this.listeNonConformites = [...this.itemToSave.datasLigneNonConformite];
      }
    }

    if (changes["idReception"] && changes["idReception"].currentValue) {
      this.getDefaultNonConformite();
     
    }

  }
}
